import { render } from "./ModalAdministrarRegional.vue?vue&type=template&id=d4adf5dc&scoped=true"
import script from "./ModalAdministrarRegional.vue?vue&type=script&lang=js"
export * from "./ModalAdministrarRegional.vue?vue&type=script&lang=js"

import "./ModalAdministrarRegional.vue?vue&type=style&index=0&id=d4adf5dc&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4adf5dc"]])

export default __exports__